import React from "react";
import {Checkbox} from "@mantine/core";
import {ScriptLanguage} from "../../types";

export type LanguageProps = {
    image: string,
    language: ScriptLanguage
    onClick: (lan: ScriptLanguage) => void,
    isSelected?: boolean
}


export function LanguageCard({image, language, onClick, isSelected}: LanguageProps) {
    return <div className={"processor-language " + (isSelected && "selected-language")}
                onClick={() => onClick(language)}>
        {isSelected && <Checkbox checked onChange={() => {
        }} className={"processor-language-select-box"}
                                 color="teal"
                                 radius="xl"
        />}
        <img src={image} alt="fireSpot" className={"fadein language-image"}/>
    </div>;
}
